import * as React from 'react';

import { cn } from '../../lib/utils';
import { LoginCard } from '../../molecules/LoginCard';

import {
  EmailVerificationFormBody,
  type EmailVerificationFormBodyProps,
} from './EmailVerificationFormBody';

export { EmailVerificationFormBody, type EmailVerificationFormBodyProps };

export interface EmailVerificationFormProps extends EmailVerificationFormBodyProps {
  /** Additional CSS classes (applied to the card) */
  className?: string;
}

/**
 * EmailVerificationForm Organism
 *
 * A verification code entry form for email verification flow: `LoginCard` chrome
 * wrapping the card-less `EmailVerificationFormBody` (title, description, boxed
 * code field, orange submit, resend link, optional back button).
 *
 * The `justify-between` on the card spreads the body's header block from its
 * bottom back button; the body returns a Fragment so those stay direct flex
 * children.
 *
 * @example
 * ```tsx
 * <EmailVerificationForm
 *   onSubmit={(code) => handleVerify(code)}
 *   onResendCode={() => handleResend()}
 *   onBack={() => navigate('/login')}
 * />
 * ```
 */
export const EmailVerificationForm = React.forwardRef<HTMLDivElement, EmailVerificationFormProps>(
  ({ className, ...bodyProps }, ref) => (
    <LoginCard ref={ref} className={cn('justify-between', className)}>
      <EmailVerificationFormBody {...bodyProps} />
    </LoginCard>
  )
);

EmailVerificationForm.displayName = 'EmailVerificationForm';

export default EmailVerificationForm;
